module.exports = __webpack_public_path__ + "img/avatar1.36694f6e.png";